"use client";
import { j as A } from "./jsx-runtime-CJ-St4mQ.mjs";
import u, { createContext as jt, useContext as Ht, useCallback as z, useRef as me, useLayoutEffect as zt, useState as ye, useEffect as $t, useMemo as we } from "react";
import { t as qt } from "./tv.config-BuYIgndg.mjs";
import { t as T, c as G, p as ie, q as Se, g as Zt, r as Rt, f as Ge, i as Gt, h as Ut, u as Kt, e as Vt, s as Jt, v as Lt, k as Ue } from "./format-CsCXRleo.mjs";
import { c as Ke } from "./createLucideIcon-BjO0sRuo.mjs";
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qt = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], Xt = Ke("chevron-left", Qt);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const en = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], tn = Ke("chevron-right", en), pe = {}, se = {};
function ae(e, t) {
  try {
    const r = (pe[e] || (pe[e] = new Intl.DateTimeFormat("en-GB", {
      timeZone: e,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1] || "";
    return r in se ? se[r] : He(r, r.split(":"));
  } catch {
    if (e in se) return se[e];
    const n = e == null ? void 0 : e.match(nn);
    return n ? He(e, n.slice(1)) : NaN;
  }
}
const nn = /([+-]\d\d):?(\d\d)?/;
function He(e, t) {
  const n = +t[0], r = +(t[1] || 0);
  return se[e] = n > 0 ? n * 60 + r : n * 60 - r;
}
class V extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(ae(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), Ve(this), _e(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new V(...n, t) : new V(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new V(+this, t);
  }
  getTimezoneOffset() {
    return -ae(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), _e(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new V(+new Date(t), this.timeZone);
  }
  //#endregion
}
const ze = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!ze.test(e)) return;
  const t = e.replace(ze, "$1UTC");
  V.prototype[t] && (e.startsWith("get") ? V.prototype[e] = function() {
    return this.internal[t]();
  } : (V.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), rn(this), +this;
  }, V.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), _e(this), +this;
  }));
});
function _e(e) {
  e.internal.setTime(+e), e.internal.setUTCMinutes(e.internal.getUTCMinutes() - e.getTimezoneOffset());
}
function rn(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), Ve(e);
}
function Ve(e) {
  const t = ae(e.timeZone, e), n = /* @__PURE__ */ new Date(+e);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), o = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), s = r - o, i = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  s && i && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + s);
  const a = r - t;
  a && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + a);
  const f = ae(e.timeZone, e), h = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - f, d = f !== t, m = h - a;
  if (d && m) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + m);
    const M = ae(e.timeZone, e), k = f - M;
    k && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + k), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + k));
  }
}
class B extends V {
  //#region static
  static tz(t, ...n) {
    return n.length ? new B(...n, t) : new B(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${on(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new B(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new B(+new Date(t), this.timeZone);
  }
  //#endregion
}
function on(e, t) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: e,
    timeZoneName: "long"
  }).format(t).slice(12);
}
var y;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(y || (y = {}));
var x;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(x || (x = {}));
var R;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(R || (R = {}));
var j;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(j || (j = {}));
function Je(e, t, n) {
  const r = T(e, n == null ? void 0 : n.in);
  return isNaN(t) ? G((n == null ? void 0 : n.in) || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Le(e, t, n) {
  const r = T(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return G(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), s = G(e, r.getTime());
  s.setMonth(r.getMonth() + t + 1, 0);
  const i = s.getDate();
  return o >= i ? s : (r.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    o
  ), r);
}
function sn(e, t, n) {
  return Je(e, t * 7, n);
}
function an(e, t, n) {
  return Le(e, t * 12, n);
}
function fn(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = G.bind(null, o));
    const s = T(o, r);
    (!n || n < s || isNaN(+s)) && (n = s);
  }), G(r, n || NaN);
}
function cn(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = G.bind(null, o));
    const s = T(o, r);
    (!n || n > s || isNaN(+s)) && (n = s);
  }), G(r, n || NaN);
}
function ln(e, t, n) {
  const [r, o] = ie(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +Se(r) == +Se(o);
}
function dn(e, t, n) {
  const [r, o] = ie(
    n == null ? void 0 : n.in,
    e,
    t
  ), s = r.getFullYear() - o.getFullYear(), i = r.getMonth() - o.getMonth();
  return s * 12 + i;
}
function un(e, t) {
  const n = T(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function hn(e, t) {
  const [n, r] = ie(e, t.start, t.end);
  return { start: n, end: r };
}
function mn(e, t) {
  const { start: n, end: r } = hn(t == null ? void 0 : t.in, e);
  let o = +n > +r;
  const s = o ? +n : +r, i = o ? r : n;
  i.setHours(0, 0, 0, 0), i.setDate(1);
  let a = 1;
  const f = [];
  for (; +i <= s; )
    f.push(G(n, i)), i.setMonth(i.getMonth() + a);
  return o ? f.reverse() : f;
}
function yn(e, t) {
  const n = T(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function Mn(e, t) {
  const n = T(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Qe(e, t) {
  var a, f, l, h;
  const n = Zt(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((f = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : f.weekStartsOn) ?? n.weekStartsOn ?? ((h = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : h.weekStartsOn) ?? 0, o = T(e, t == null ? void 0 : t.in), s = o.getDay(), i = (s < r ? -7 : 0) + 6 - (s - r);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function Dn(e, t) {
  return Qe(e, { ...t, weekStartsOn: 1 });
}
function kn(e, t) {
  const n = T(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = n.getMonth(), s = G(n, 0);
  return s.setFullYear(r, o + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function vn(e, t) {
  return T(e, t == null ? void 0 : t.in).getMonth();
}
function bn(e, t) {
  return T(e, t == null ? void 0 : t.in).getFullYear();
}
function gn(e, t) {
  return +T(e) > +T(t);
}
function On(e, t) {
  return +T(e) < +T(t);
}
function wn(e, t, n) {
  const [r, o] = ie(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function pn(e, t, n) {
  const [r, o] = ie(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function Nn(e, t, n) {
  const r = T(e, n == null ? void 0 : n.in), o = r.getFullYear(), s = r.getDate(), i = G(e, 0);
  i.setFullYear(o, t, 15), i.setHours(0, 0, 0, 0);
  const a = kn(i);
  return r.setMonth(t, Math.min(s, a)), r;
}
function Wn(e, t, n) {
  const r = T(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? G(e, NaN) : (r.setFullYear(t), r);
}
const $e = 5, Cn = 4;
function Sn(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), s = t.addDays(o, $e * 7 - 1);
  return t.getMonth(e) === t.getMonth(s) ? $e : Cn;
}
function Xe(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -1 * 6) : t.addDays(n, -1 * (r - 1));
}
function _n(e, t) {
  const n = Xe(e, t), r = Sn(e, t);
  return t.addDays(n, r * 7 - 1);
}
class ee {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => {
      var r;
      return (r = this.overrides) != null && r.today ? this.overrides.today() : this.options.timeZone ? B.tz(this.options.timeZone) : new this.Date();
    }, this.newDate = (r, o, s) => {
      var i;
      return (i = this.overrides) != null && i.newDate ? this.overrides.newDate(r, o, s) : this.options.timeZone ? new B(r, o, s, this.options.timeZone) : new Date(r, o, s);
    }, this.addDays = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addDays ? this.overrides.addDays(r, o) : Je(r, o);
    }, this.addMonths = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addMonths ? this.overrides.addMonths(r, o) : Le(r, o);
    }, this.addWeeks = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addWeeks ? this.overrides.addWeeks(r, o) : sn(r, o);
    }, this.addYears = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addYears ? this.overrides.addYears(r, o) : an(r, o);
    }, this.differenceInCalendarDays = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : Rt(r, o);
    }, this.differenceInCalendarMonths = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : dn(r, o);
    }, this.eachMonthOfInterval = (r) => {
      var o;
      return (o = this.overrides) != null && o.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : mn(r);
    }, this.endOfBroadcastWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : _n(r, this);
    }, this.endOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfISOWeek ? this.overrides.endOfISOWeek(r) : Dn(r);
    }, this.endOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfMonth ? this.overrides.endOfMonth(r) : un(r);
    }, this.endOfWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.endOfWeek ? this.overrides.endOfWeek(r, o) : Qe(r, this.options);
    }, this.endOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfYear ? this.overrides.endOfYear(r) : Mn(r);
    }, this.format = (r, o, s) => {
      var a;
      const i = (a = this.overrides) != null && a.format ? this.overrides.format(r, o, this.options) : Ge(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(i) : i;
    }, this.getISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.getISOWeek ? this.overrides.getISOWeek(r) : Gt(r);
    }, this.getMonth = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.getMonth ? this.overrides.getMonth(r, this.options) : vn(r, this.options);
    }, this.getYear = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.getYear ? this.overrides.getYear(r, this.options) : bn(r, this.options);
    }, this.getWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.getWeek ? this.overrides.getWeek(r, this.options) : Ut(r, this.options);
    }, this.isAfter = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isAfter ? this.overrides.isAfter(r, o) : gn(r, o);
    }, this.isBefore = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isBefore ? this.overrides.isBefore(r, o) : On(r, o);
    }, this.isDate = (r) => {
      var o;
      return (o = this.overrides) != null && o.isDate ? this.overrides.isDate(r) : Kt(r);
    }, this.isSameDay = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isSameDay ? this.overrides.isSameDay(r, o) : ln(r, o);
    }, this.isSameMonth = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isSameMonth ? this.overrides.isSameMonth(r, o) : wn(r, o);
    }, this.isSameYear = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isSameYear ? this.overrides.isSameYear(r, o) : pn(r, o);
    }, this.max = (r) => {
      var o;
      return (o = this.overrides) != null && o.max ? this.overrides.max(r) : fn(r);
    }, this.min = (r) => {
      var o;
      return (o = this.overrides) != null && o.min ? this.overrides.min(r) : cn(r);
    }, this.setMonth = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.setMonth ? this.overrides.setMonth(r, o) : Nn(r, o);
    }, this.setYear = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.setYear ? this.overrides.setYear(r, o) : Wn(r, o);
    }, this.startOfBroadcastWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : Xe(r, this);
    }, this.startOfDay = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfDay ? this.overrides.startOfDay(r) : Se(r);
    }, this.startOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Vt(r);
    }, this.startOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfMonth ? this.overrides.startOfMonth(r) : yn(r);
    }, this.startOfWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.startOfWeek ? this.overrides.startOfWeek(r, this.options) : Jt(r, this.options);
    }, this.startOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfYear ? this.overrides.startOfYear(r) : Lt(r);
    }, this.options = { locale: Ue, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
}
const J = new ee();
class et {
  constructor(t, n, r = J) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class En {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class xn {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function Q(e, t, n = !1, r = J) {
  let { from: o, to: s } = e;
  const { differenceInCalendarDays: i, isSameDay: a } = r;
  return o && s ? (i(s, o) < 0 && ([o, s] = [s, o]), i(t, o) >= (n ? 1 : 0) && i(s, t) >= (n ? 1 : 0)) : !n && s ? a(s, t) : !n && o ? a(o, t) : !1;
}
function tt(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function Ee(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function nt(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function rt(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function ot(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function st(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function X(e, t, n = J) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: s, isAfter: i } = n;
  return r.some((a) => {
    if (typeof a == "boolean")
      return a;
    if (n.isDate(a))
      return o(e, a);
    if (st(a, n))
      return a.includes(e);
    if (Ee(a))
      return Q(a, e, !1, n);
    if (ot(a))
      return Array.isArray(a.dayOfWeek) ? a.dayOfWeek.includes(e.getDay()) : a.dayOfWeek === e.getDay();
    if (tt(a)) {
      const f = s(a.before, e), l = s(a.after, e), h = f > 0, d = l < 0;
      return i(a.before, a.after) ? d && h : h || d;
    }
    return nt(a) ? s(e, a.after) > 0 : rt(a) ? s(a.before, e) > 0 : typeof a == "function" ? a(e) : !1;
  });
}
function Tn(e, t, n) {
  const { disabled: r, hidden: o, modifiers: s, showOutsideDays: i, broadcastCalendar: a, today: f } = t, { isSameDay: l, isSameMonth: h, startOfMonth: d, isBefore: m, endOfMonth: M, isAfter: k } = n, p = t.startMonth && d(t.startMonth), b = t.endMonth && M(t.endMonth), v = {
    [x.focused]: [],
    [x.outside]: [],
    [x.disabled]: [],
    [x.hidden]: [],
    [x.today]: []
  }, N = {};
  for (const D of e) {
    const { date: C, displayMonth: c } = D, O = !!(c && !h(C, c)), g = !!(p && m(C, p)), _ = !!(b && k(C, b)), H = !!(r && X(C, r, n)), P = !!(o && X(C, o, n)) || g || _ || // Broadcast calendar will show outside days as default
    !a && !i && O || a && i === !1 && O, I = l(C, f ?? n.today());
    O && v.outside.push(D), H && v.disabled.push(D), P && v.hidden.push(D), I && v.today.push(D), s && Object.keys(s).forEach((F) => {
      const ne = s == null ? void 0 : s[F];
      ne && X(C, ne, n) && (N[F] ? N[F].push(D) : N[F] = [D]);
    });
  }
  return (D) => {
    const C = {
      [x.focused]: !1,
      [x.disabled]: !1,
      [x.hidden]: !1,
      [x.outside]: !1,
      [x.today]: !1
    }, c = {};
    for (const O in v) {
      const g = v[O];
      C[O] = g.some((_) => _ === D);
    }
    for (const O in N)
      c[O] = N[O].some((g) => g === D);
    return {
      ...C,
      // custom modifiers should override all the previous ones
      ...c
    };
  };
}
function Yn(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [s]) => (n[s] ? o.push(n[s]) : t[x[s]] ? o.push(t[x[s]]) : t[R[s]] && o.push(t[R[s]]), o), [t[y.Day]]);
}
function Bn(e) {
  return u.createElement("button", { ...e });
}
function In(e) {
  return u.createElement("span", { ...e });
}
function Fn(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return u.createElement(
    "svg",
    { className: r, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && u.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && u.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && u.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && u.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function Pn(e) {
  const { day: t, modifiers: n, ...r } = e;
  return u.createElement("td", { ...r });
}
function An(e) {
  const { day: t, modifiers: n, ...r } = e, o = u.useRef(null);
  return u.useEffect(() => {
    var s;
    n.focused && ((s = o.current) == null || s.focus());
  }, [n.focused]), u.createElement("button", { ref: o, ...r });
}
function jn(e) {
  const { options: t, className: n, components: r, classNames: o, ...s } = e, i = [o[y.Dropdown], n].join(" "), a = t == null ? void 0 : t.find(({ value: f }) => f === s.value);
  return u.createElement(
    "span",
    { "data-disabled": s.disabled, className: o[y.DropdownRoot] },
    u.createElement(r.Select, { className: i, ...s }, t == null ? void 0 : t.map(({ value: f, label: l, disabled: h }) => u.createElement(r.Option, { key: f, value: f, disabled: h }, l))),
    u.createElement(
      "span",
      { className: o[y.CaptionLabel], "aria-hidden": !0 },
      a == null ? void 0 : a.label,
      u.createElement(r.Chevron, { orientation: "down", size: 18, className: o[y.Chevron] })
    )
  );
}
function Hn(e) {
  return u.createElement("div", { ...e });
}
function zn(e) {
  return u.createElement("div", { ...e });
}
function $n(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return u.createElement("div", { ...r }, e.children);
}
function qn(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return u.createElement("div", { ...r });
}
function Zn(e) {
  return u.createElement("table", { ...e });
}
function Rn(e) {
  return u.createElement("div", { ...e });
}
const at = jt(void 0);
function fe() {
  const e = Ht(at);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function Gn(e) {
  const { components: t } = fe();
  return u.createElement(t.Dropdown, { ...e });
}
function Un(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...s } = e, { components: i, classNames: a, labels: { labelPrevious: f, labelNext: l } } = fe(), h = z((m) => {
    o && (n == null || n(m));
  }, [o, n]), d = z((m) => {
    r && (t == null || t(m));
  }, [r, t]);
  return u.createElement(
    "nav",
    { ...s },
    u.createElement(
      i.PreviousMonthButton,
      { type: "button", className: a[y.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": f(r), onClick: d },
      u.createElement(i.Chevron, { disabled: r ? void 0 : !0, className: a[y.Chevron], orientation: "left" })
    ),
    u.createElement(
      i.NextMonthButton,
      { type: "button", className: a[y.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": l(o), onClick: h },
      u.createElement(i.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: a[y.Chevron] })
    )
  );
}
function Kn(e) {
  const { components: t } = fe();
  return u.createElement(t.Button, { ...e });
}
function Vn(e) {
  return u.createElement("option", { ...e });
}
function Jn(e) {
  const { components: t } = fe();
  return u.createElement(t.Button, { ...e });
}
function Ln(e) {
  const { rootRef: t, ...n } = e;
  return u.createElement("div", { ...n, ref: t });
}
function Qn(e) {
  return u.createElement("select", { ...e });
}
function Xn(e) {
  const { week: t, ...n } = e;
  return u.createElement("tr", { ...n });
}
function er(e) {
  return u.createElement("th", { ...e });
}
function tr(e) {
  return u.createElement(
    "thead",
    { "aria-hidden": !0 },
    u.createElement("tr", { ...e })
  );
}
function nr(e) {
  const { week: t, ...n } = e;
  return u.createElement("th", { ...n });
}
function rr(e) {
  return u.createElement("th", { ...e });
}
function or(e) {
  return u.createElement("tbody", { ...e });
}
function sr(e) {
  const { components: t } = fe();
  return u.createElement(t.Dropdown, { ...e });
}
const ar = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Bn,
  CaptionLabel: In,
  Chevron: Fn,
  Day: Pn,
  DayButton: An,
  Dropdown: jn,
  DropdownNav: Hn,
  Footer: zn,
  Month: $n,
  MonthCaption: qn,
  MonthGrid: Zn,
  Months: Rn,
  MonthsDropdown: Gn,
  Nav: Un,
  NextMonthButton: Kn,
  Option: Vn,
  PreviousMonthButton: Jn,
  Root: Ln,
  Select: Qn,
  Week: Xn,
  WeekNumber: nr,
  WeekNumberHeader: rr,
  Weekday: er,
  Weekdays: tr,
  Weeks: or,
  YearsDropdown: sr
}, Symbol.toStringTag, { value: "Module" }));
function ir(e) {
  return {
    ...ar,
    ...e
  };
}
function fr(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function cr() {
  const e = {};
  for (const t in y)
    e[y[t]] = `rdp-${y[t]}`;
  for (const t in x)
    e[x[t]] = `rdp-${x[t]}`;
  for (const t in R)
    e[R[t]] = `rdp-${R[t]}`;
  for (const t in j)
    e[j[t]] = `rdp-${j[t]}`;
  return e;
}
function it(e, t, n) {
  return (n ?? new ee(t)).format(e, "LLLL y");
}
const lr = it;
function dr(e, t, n) {
  return (n ?? new ee(t)).format(e, "d");
}
function ur(e, t = J) {
  return t.format(e, "LLLL");
}
function hr(e, t = J) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function mr() {
  return "";
}
function yr(e, t, n) {
  return (n ?? new ee(t)).format(e, "cccccc");
}
function ft(e, t = J) {
  return t.format(e, "yyyy");
}
const Mr = ft, Dr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: it,
  formatDay: dr,
  formatMonthCaption: lr,
  formatMonthDropdown: ur,
  formatWeekNumber: hr,
  formatWeekNumberHeader: mr,
  formatWeekdayName: yr,
  formatYearCaption: Mr,
  formatYearDropdown: ft
}, Symbol.toStringTag, { value: "Module" }));
function kr(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...Dr,
    ...e
  };
}
function vr(e, t, n, r, o) {
  const { startOfMonth: s, startOfYear: i, endOfYear: a, eachMonthOfInterval: f, getMonth: l } = o;
  return f({
    start: i(e),
    end: a(e)
  }).map((m) => {
    const M = r.formatMonthDropdown(m, o), k = l(m), p = t && m < s(t) || n && m > s(n) || !1;
    return { value: k, label: M, disabled: p };
  });
}
function br(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[y.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[o]
    };
  }), r;
}
function gr(e, t, n) {
  const r = e.today(), o = t ? e.startOfISOWeek(r) : e.startOfWeek(r), s = [];
  for (let i = 0; i < 7; i++) {
    const a = e.addDays(o, i);
    s.push(a);
  }
  return s;
}
function Or(e, t, n, r) {
  if (!e || !t)
    return;
  const { startOfYear: o, endOfYear: s, addYears: i, getYear: a, isBefore: f, isSameYear: l } = r, h = o(e), d = s(t), m = [];
  let M = h;
  for (; f(M, d) || l(M, d); )
    m.push(M), M = i(M, 1);
  return m.map((k) => {
    const p = n.formatYearDropdown(k, r);
    return {
      value: a(k),
      label: p,
      disabled: !1
    };
  });
}
function ct(e, t, n) {
  return (n ?? new ee(t)).format(e, "LLLL y");
}
const wr = ct;
function pr(e, t, n, r) {
  let o = (r ?? new ee(n)).format(e, "PPPP");
  return t != null && t.today && (o = `Today, ${o}`), o;
}
function lt(e, t, n, r) {
  let o = (r ?? new ee(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
const Nr = lt;
function Wr() {
  return "";
}
function Cr(e) {
  return "Choose the Month";
}
function Sr(e) {
  return "Go to the Next Month";
}
function _r(e) {
  return "Go to the Previous Month";
}
function Er(e, t, n) {
  return (n ?? new ee(t)).format(e, "cccc");
}
function xr(e, t) {
  return `Week ${e}`;
}
function Tr(e) {
  return "Week Number";
}
function Yr(e) {
  return "Choose the Year";
}
const Br = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: wr,
  labelDay: Nr,
  labelDayButton: lt,
  labelGrid: ct,
  labelGridcell: pr,
  labelMonthDropdown: Cr,
  labelNav: Wr,
  labelNext: Sr,
  labelPrevious: _r,
  labelWeekNumber: xr,
  labelWeekNumberHeader: Tr,
  labelWeekday: Er,
  labelYearDropdown: Yr
}, Symbol.toStringTag, { value: "Module" })), ce = (e) => e instanceof HTMLElement ? e : null, Ne = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], Ir = (e) => ce(e.querySelector("[data-animated-month]")), We = (e) => ce(e.querySelector("[data-animated-caption]")), Ce = (e) => ce(e.querySelector("[data-animated-weeks]")), Fr = (e) => ce(e.querySelector("[data-animated-nav]")), Pr = (e) => ce(e.querySelector("[data-animated-weekdays]"));
function Ar(e, t, { classNames: n, months: r, focused: o, dateLib: s }) {
  const i = me(null), a = me(r), f = me(!1);
  zt(() => {
    const l = a.current;
    if (a.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || l.length === 0 || r.length !== l.length)
      return;
    const h = s.isSameMonth(r[0].date, l[0].date), d = s.isAfter(r[0].date, l[0].date), m = d ? n[j.caption_after_enter] : n[j.caption_before_enter], M = d ? n[j.weeks_after_enter] : n[j.weeks_before_enter], k = i.current, p = e.current.cloneNode(!0);
    if (p instanceof HTMLElement ? (Ne(p).forEach((D) => {
      if (!(D instanceof HTMLElement))
        return;
      const C = Ir(D);
      C && D.contains(C) && D.removeChild(C);
      const c = We(D);
      c && c.classList.remove(m);
      const O = Ce(D);
      O && O.classList.remove(M);
    }), i.current = p) : i.current = null, f.current || h || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const b = k instanceof HTMLElement ? Ne(k) : [], v = Ne(e.current);
    if (v && v.every((N) => N instanceof HTMLElement) && b && b.every((N) => N instanceof HTMLElement)) {
      f.current = !0, e.current.style.isolation = "isolate";
      const N = Fr(e.current);
      N && (N.style.zIndex = "1"), v.forEach((D, C) => {
        const c = b[C];
        if (!c)
          return;
        D.style.position = "relative", D.style.overflow = "hidden";
        const O = We(D);
        O && O.classList.add(m);
        const g = Ce(D);
        g && g.classList.add(M);
        const _ = () => {
          f.current = !1, e.current && (e.current.style.isolation = ""), N && (N.style.zIndex = ""), O && O.classList.remove(m), g && g.classList.remove(M), D.style.position = "", D.style.overflow = "", D.contains(c) && D.removeChild(c);
        };
        c.style.pointerEvents = "none", c.style.position = "absolute", c.style.overflow = "hidden", c.setAttribute("aria-hidden", "true");
        const H = Pr(c);
        H && (H.style.opacity = "0");
        const P = We(c);
        P && (P.classList.add(d ? n[j.caption_before_exit] : n[j.caption_after_exit]), P.addEventListener("animationend", _));
        const I = Ce(c);
        I && I.classList.add(d ? n[j.weeks_before_exit] : n[j.weeks_after_exit]), D.insertBefore(c, D.firstChild);
      });
    }
  });
}
function jr(e, t, n, r) {
  const o = e[0], s = e[e.length - 1], { ISOWeek: i, fixedWeeks: a, broadcastCalendar: f } = n ?? {}, { addDays: l, differenceInCalendarDays: h, differenceInCalendarMonths: d, endOfBroadcastWeek: m, endOfISOWeek: M, endOfMonth: k, endOfWeek: p, isAfter: b, startOfBroadcastWeek: v, startOfISOWeek: N, startOfWeek: D } = r, C = f ? v(o, r) : i ? N(o) : D(o), c = f ? m(s) : i ? M(k(s)) : p(k(s)), O = h(c, C), g = d(s, o) + 1, _ = [];
  for (let I = 0; I <= O; I++) {
    const F = l(C, I);
    if (t && b(F, t))
      break;
    _.push(F);
  }
  const P = (f ? 35 : 42) * g;
  if (a && _.length < P) {
    const I = P - _.length;
    for (let F = 0; F < I; F++) {
      const ne = l(_[_.length - 1], 1);
      _.push(ne);
    }
  }
  return _;
}
function Hr(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((s, i) => [...s, ...i.days], t);
    return [...n, ...o];
  }, t);
}
function zr(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, s = [];
  for (let i = 0; i < o; i++) {
    const a = r.addMonths(e, i);
    if (t && a > t)
      break;
    s.push(a);
  }
  return s;
}
function qe(e, t) {
  const { month: n, defaultMonth: r, today: o = t.today(), numberOfMonths: s = 1, endMonth: i, startMonth: a } = e;
  let f = n || r || o;
  const { differenceInCalendarMonths: l, addMonths: h, startOfMonth: d } = t;
  if (i && l(i, f) < 0) {
    const m = -1 * (s - 1);
    f = h(i, m);
  }
  return a && l(f, a) < 0 && (f = a), d(f);
}
function $r(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: s, endOfISOWeek: i, endOfMonth: a, endOfWeek: f, getISOWeek: l, getWeek: h, startOfBroadcastWeek: d, startOfISOWeek: m, startOfWeek: M } = r, k = e.reduce((p, b) => {
    const v = n.broadcastCalendar ? d(b, r) : n.ISOWeek ? m(b) : M(b), N = n.broadcastCalendar ? s(b) : n.ISOWeek ? i(a(b)) : f(a(b)), D = t.filter((g) => g >= v && g <= N), C = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && D.length < C) {
      const g = t.filter((_) => {
        const H = C - D.length;
        return _ > N && _ <= o(N, H);
      });
      D.push(...g);
    }
    const c = D.reduce((g, _) => {
      const H = n.ISOWeek ? l(_) : h(_), P = g.find((F) => F.weekNumber === H), I = new et(_, b, r);
      return P ? P.days.push(I) : g.push(new xn(H, [I])), g;
    }, []), O = new En(b, c);
    return p.push(O), p;
  }, []);
  return n.reverseMonths ? k.reverse() : k;
}
function qr(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: s, startOfMonth: i, endOfMonth: a, addYears: f, endOfYear: l, newDate: h, today: d } = t, { fromYear: m, toYear: M, fromMonth: k, toMonth: p } = e;
  !n && k && (n = k), !n && m && (n = t.newDate(m, 0, 1)), !r && p && (r = p), !r && M && (r = h(M, 11, 31));
  const b = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = i(n) : m ? n = h(m, 0, 1) : !n && b && (n = o(f(e.today ?? d(), -100))), r ? r = a(r) : M ? r = h(M, 11, 31) : !r && b && (r = l(e.today ?? d())), [
    n && s(n),
    r && s(r)
  ];
}
function Zr(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: s = 1 } = n, { startOfMonth: i, addMonths: a, differenceInCalendarMonths: f } = r, l = o ? s : 1, h = i(e);
  if (!t)
    return a(h, l);
  if (!(f(t, e) < s))
    return a(h, l);
}
function Rr(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: s } = n, { startOfMonth: i, addMonths: a, differenceInCalendarMonths: f } = r, l = o ? s ?? 1 : 1, h = i(e);
  if (!t)
    return a(h, -l);
  if (!(f(h, t) <= 0))
    return a(h, -l);
}
function Gr(e) {
  const t = [];
  return e.reduce((n, r) => [...n, ...r.weeks], t);
}
function Me(e, t) {
  const [n, r] = ye(e);
  return [t === void 0 ? n : t, r];
}
function Ur(e, t) {
  const [n, r] = qr(e, t), { startOfMonth: o, endOfMonth: s } = t, i = qe(e, t), [a, f] = Me(
    i,
    // initialMonth is always computed from props.month if provided
    e.month ? i : void 0
  );
  $t(() => {
    const O = qe(e, t);
    f(O);
  }, [e.timeZone]);
  const l = zr(a, r, e, t), h = jr(l, e.endMonth ? s(e.endMonth) : void 0, e, t), d = $r(l, h, e, t), m = Gr(d), M = Hr(d), k = Rr(a, n, e, t), p = Zr(a, r, e, t), { disableNavigation: b, onMonthChange: v } = e, N = (O) => m.some((g) => g.days.some((_) => _.isEqualTo(O))), D = (O) => {
    if (b)
      return;
    let g = o(O);
    n && g < o(n) && (g = o(n)), r && g > o(r) && (g = o(r)), f(g), v == null || v(g);
  };
  return {
    months: d,
    weeks: m,
    days: M,
    navStart: n,
    navEnd: r,
    previousMonth: k,
    nextMonth: p,
    goToMonth: D,
    goToDay: (O) => {
      N(O) || D(O.date);
    }
  };
}
var K;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(K || (K = {}));
function Ze(e) {
  return !e[x.disabled] && !e[x.hidden] && !e[x.outside];
}
function Kr(e, t, n, r) {
  let o, s = -1;
  for (const i of e) {
    const a = t(i);
    Ze(a) && (a[x.focused] && s < K.FocusedModifier ? (o = i, s = K.FocusedModifier) : r != null && r.isEqualTo(i) && s < K.LastFocused ? (o = i, s = K.LastFocused) : n(i.date) && s < K.Selected ? (o = i, s = K.Selected) : a[x.today] && s < K.Today && (o = i, s = K.Today));
  }
  return o || (o = e.find((i) => Ze(t(i)))), o;
}
function Vr(e, t, n, r, o, s, i) {
  const { ISOWeek: a, broadcastCalendar: f } = s, { addDays: l, addMonths: h, addWeeks: d, addYears: m, endOfBroadcastWeek: M, endOfISOWeek: k, endOfWeek: p, max: b, min: v, startOfBroadcastWeek: N, startOfISOWeek: D, startOfWeek: C } = i;
  let O = {
    day: l,
    week: d,
    month: h,
    year: m,
    startOfWeek: (g) => f ? N(g, i) : a ? D(g) : C(g),
    endOfWeek: (g) => f ? M(g) : a ? k(g) : p(g)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? O = b([r, O]) : t === "after" && o && (O = v([o, O])), O;
}
function dt(e, t, n, r, o, s, i, a = 0) {
  if (a > 365)
    return;
  const f = Vr(e, t, n.date, r, o, s, i), l = !!(s.disabled && X(f, s.disabled, i)), h = !!(s.hidden && X(f, s.hidden, i)), d = f, m = new et(f, d, i);
  return !l && !h ? m : dt(e, t, m, r, o, s, i, a + 1);
}
function Jr(e, t, n, r, o) {
  const { autoFocus: s } = e, [i, a] = ye(), f = Kr(t.days, n, r || (() => !1), i), [l, h] = ye(s ? f : void 0);
  return {
    isFocusTarget: (p) => !!(f != null && f.isEqualTo(p)),
    setFocused: h,
    focused: l,
    blur: () => {
      a(l), h(void 0);
    },
    moveFocus: (p, b) => {
      if (!l)
        return;
      const v = dt(p, b, l, t.navStart, t.navEnd, e, o);
      v && (t.goToDay(v), h(v));
    }
  };
}
function Lr(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [s, i] = Me(n, o ? n : void 0), a = o ? n : s, { isSameDay: f } = t, l = (M) => (a == null ? void 0 : a.some((k) => f(k, M))) ?? !1, { min: h, max: d } = e;
  return {
    selected: a,
    select: (M, k, p) => {
      let b = [...a ?? []];
      if (l(M)) {
        if ((a == null ? void 0 : a.length) === h || r && (a == null ? void 0 : a.length) === 1)
          return;
        b = a == null ? void 0 : a.filter((v) => !f(v, M));
      } else
        (a == null ? void 0 : a.length) === d ? b = [M] : b = [...b, M];
      return o || i(b), o == null || o(b, M, k, p), b;
    },
    isSelected: l
  };
}
function Qr(e, t, n = 0, r = 0, o = !1, s = J) {
  const { from: i, to: a } = t || {}, { isSameDay: f, isAfter: l, isBefore: h } = s;
  let d;
  if (!i && !a)
    d = { from: e, to: n > 0 ? void 0 : e };
  else if (i && !a)
    f(i, e) ? o ? d = { from: i, to: void 0 } : d = void 0 : h(e, i) ? d = { from: e, to: i } : d = { from: i, to: e };
  else if (i && a)
    if (f(i, e) && f(a, e))
      o ? d = { from: i, to: a } : d = void 0;
    else if (f(i, e))
      d = { from: i, to: n > 0 ? void 0 : e };
    else if (f(a, e))
      d = { from: e, to: n > 0 ? void 0 : e };
    else if (h(e, i))
      d = { from: e, to: a };
    else if (l(e, i))
      d = { from: i, to: e };
    else if (l(e, a))
      d = { from: i, to: e };
    else
      throw new Error("Invalid range");
  if (d != null && d.from && (d != null && d.to)) {
    const m = s.differenceInCalendarDays(d.to, d.from);
    r > 0 && m > r ? d = { from: e, to: void 0 } : n > 1 && m < n && (d = { from: e, to: void 0 });
  }
  return d;
}
function Xr(e, t, n = J) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const s = n.differenceInCalendarDays(e.to, e.from), i = Math.min(s, 6);
  for (let a = 0; a <= i; a++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function Re(e, t, n = J) {
  return Q(e, t.from, !1, n) || Q(e, t.to, !1, n) || Q(t, e.from, !1, n) || Q(t, e.to, !1, n);
}
function eo(e, t, n = J) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((a) => typeof a != "function").some((a) => typeof a == "boolean" ? a : n.isDate(a) ? Q(e, a, !1, n) : st(a, n) ? a.some((f) => Q(e, f, !1, n)) : Ee(a) ? a.from && a.to ? Re(e, { from: a.from, to: a.to }, n) : !1 : ot(a) ? Xr(e, a.dayOfWeek, n) : tt(a) ? n.isAfter(a.before, a.after) ? Re(e, {
    from: n.addDays(a.after, 1),
    to: n.addDays(a.before, -1)
  }, n) : X(e.from, a, n) || X(e.to, a, n) : nt(a) || rt(a) ? X(e.from, a, n) || X(e.to, a, n) : !1))
    return !0;
  const i = r.filter((a) => typeof a == "function");
  if (i.length) {
    let a = e.from;
    const f = n.differenceInCalendarDays(e.to, e.from);
    for (let l = 0; l <= f; l++) {
      if (i.some((h) => h(a)))
        return !0;
      a = n.addDays(a, 1);
    }
  }
  return !1;
}
function to(e, t) {
  const { disabled: n, excludeDisabled: r, selected: o, required: s, onSelect: i } = e, [a, f] = Me(o, i ? o : void 0), l = i ? o : a;
  return {
    selected: l,
    select: (m, M, k) => {
      const { min: p, max: b } = e, v = m ? Qr(m, l, p, b, s, t) : void 0;
      return r && n && (v != null && v.from) && v.to && eo({ from: v.from, to: v.to }, n, t) && (v.from = m, v.to = void 0), i || f(v), i == null || i(v, m, M, k), v;
    },
    isSelected: (m) => l && Q(l, m, !1, t)
  };
}
function no(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [s, i] = Me(n, o ? n : void 0), a = o ? n : s, { isSameDay: f } = t;
  return {
    selected: a,
    select: (d, m, M) => {
      let k = d;
      return !r && a && a && f(d, a) && (k = void 0), o || i(k), o == null || o(k, d, m, M), k;
    },
    isSelected: (d) => a ? f(a, d) : !1
  };
}
function ro(e, t) {
  const n = no(e, t), r = Lr(e, t), o = to(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function oo(e) {
  var je;
  let t = e;
  t.timeZone && (t = {
    ...e
  }, t.today && (t.today = new B(t.today, t.timeZone)), t.month && (t.month = new B(t.month, t.timeZone)), t.defaultMonth && (t.defaultMonth = new B(t.defaultMonth, t.timeZone)), t.startMonth && (t.startMonth = new B(t.startMonth, t.timeZone)), t.endMonth && (t.endMonth = new B(t.endMonth, t.timeZone)), t.mode === "single" && t.selected ? t.selected = new B(t.selected, t.timeZone) : t.mode === "multiple" && t.selected ? t.selected = (je = t.selected) == null ? void 0 : je.map((w) => new B(w, t.timeZone)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? new B(t.selected.from, t.timeZone) : void 0,
    to: t.selected.to ? new B(t.selected.to, t.timeZone) : void 0
  }));
  const { components: n, formatters: r, labels: o, dateLib: s, locale: i, classNames: a } = we(() => {
    const w = { ...Ue, ...t.locale };
    return {
      dateLib: new ee({
        locale: w,
        weekStartsOn: t.broadcastCalendar ? 1 : t.weekStartsOn,
        firstWeekContainsDate: t.firstWeekContainsDate,
        useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
        timeZone: t.timeZone,
        numerals: t.numerals
      }, t.dateLib),
      components: ir(t.components),
      formatters: kr(t.formatters),
      labels: { ...Br, ...t.labels },
      locale: w,
      classNames: { ...cr(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]), { captionLayout: f, mode: l, navLayout: h, numberOfMonths: d = 1, onDayBlur: m, onDayClick: M, onDayFocus: k, onDayKeyDown: p, onDayMouseEnter: b, onDayMouseLeave: v, onNextClick: N, onPrevClick: D, showWeekNumber: C, styles: c } = t, { formatCaption: O, formatDay: g, formatMonthDropdown: _, formatWeekNumber: H, formatWeekNumberHeader: P, formatWeekdayName: I, formatYearDropdown: F } = r, ne = Ur(t, s), { days: xe, months: De, navStart: Te, navEnd: Ye, previousMonth: $, nextMonth: q, goToMonth: L } = ne, ke = Tn(xe, t, s), { isSelected: re, select: oe, selected: le } = ro(t, s) ?? {}, { blur: Be, focused: de, isFocusTarget: ut, moveFocus: Ie, setFocused: ue } = Jr(t, ne, ke, re ?? (() => !1), s), { labelDayButton: ht, labelGridcell: mt, labelGrid: yt, labelMonthDropdown: Mt, labelNav: Fe, labelPrevious: Dt, labelNext: kt, labelWeekday: vt, labelWeekNumber: bt, labelWeekNumberHeader: gt, labelYearDropdown: Ot } = o, wt = we(() => gr(s, t.ISOWeek), [s, t.ISOWeek]), Pe = l !== void 0 || M !== void 0, ve = z(() => {
    $ && (L($), D == null || D($));
  }, [$, L, D]), be = z(() => {
    q && (L(q), N == null || N(q));
  }, [L, q, N]), pt = z((w, E) => (S) => {
    S.preventDefault(), S.stopPropagation(), ue(w), oe == null || oe(w.date, E, S), M == null || M(w.date, E, S);
  }, [oe, M, ue]), Nt = z((w, E) => (S) => {
    ue(w), k == null || k(w.date, E, S);
  }, [k, ue]), Wt = z((w, E) => (S) => {
    Be(), m == null || m(w.date, E, S);
  }, [Be, m]), Ct = z((w, E) => (S) => {
    const te = {
      ArrowLeft: ["day", t.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", t.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [S.shiftKey ? "year" : "month", "before"],
      PageDown: [S.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (te[S.key]) {
      S.preventDefault(), S.stopPropagation();
      const [Z, he] = te[S.key];
      Ie(Z, he);
    }
    p == null || p(w.date, E, S);
  }, [Ie, p, t.dir]), St = z((w, E) => (S) => {
    b == null || b(w.date, E, S);
  }, [b]), _t = z((w, E) => (S) => {
    v == null || v(w.date, E, S);
  }, [v]), Et = z((w) => (E) => {
    const S = Number(E.target.value), te = s.setMonth(s.startOfMonth(w), S);
    L(te);
  }, [s, L]), xt = z((w) => (E) => {
    const S = Number(E.target.value), te = s.setYear(s.startOfMonth(w), S);
    L(te);
  }, [s, L]), { className: Tt, style: Yt } = we(() => ({
    className: [a[y.Root], t.className].filter(Boolean).join(" "),
    style: { ...c == null ? void 0 : c[y.Root], ...t.style }
  }), [a, t.className, t.style, c]), Bt = fr(t), Ae = me(null);
  Ar(Ae, !!t.animate, {
    classNames: a,
    months: De,
    focused: de,
    dateLib: s
  });
  const It = {
    dayPickerProps: t,
    selected: le,
    select: oe,
    isSelected: re,
    months: De,
    nextMonth: q,
    previousMonth: $,
    goToMonth: L,
    getModifiers: ke,
    components: n,
    classNames: a,
    styles: c,
    labels: o,
    formatters: r
  };
  return u.createElement(
    at.Provider,
    { value: It },
    u.createElement(
      n.Root,
      { rootRef: t.animate ? Ae : void 0, className: Tt, style: Yt, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], ...Bt },
      u.createElement(
        n.Months,
        { className: a[y.Months], style: c == null ? void 0 : c[y.Months] },
        !t.hideNavigation && !h && u.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: a[y.Nav], style: c == null ? void 0 : c[y.Nav], "aria-label": Fe(), onPreviousClick: ve, onNextClick: be, previousMonth: $, nextMonth: q }),
        De.map((w, E) => {
          const S = vr(w.date, Te, Ye, r, s), te = Or(Te, Ye, r, s);
          return u.createElement(
            n.Month,
            { "data-animated-month": t.animate ? "true" : void 0, className: a[y.Month], style: c == null ? void 0 : c[y.Month], key: E, displayIndex: E, calendarMonth: w },
            h === "around" && !t.hideNavigation && E === 0 && u.createElement(
              n.PreviousMonthButton,
              { type: "button", className: a[y.PreviousMonthButton], tabIndex: $ ? void 0 : -1, "aria-disabled": $ ? void 0 : !0, "aria-label": Dt($), onClick: ve, "data-animated-button": t.animate ? "true" : void 0 },
              u.createElement(n.Chevron, { disabled: $ ? void 0 : !0, className: a[y.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
            ),
            u.createElement(n.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: a[y.MonthCaption], style: c == null ? void 0 : c[y.MonthCaption], calendarMonth: w, displayIndex: E }, f != null && f.startsWith("dropdown") ? u.createElement(
              n.DropdownNav,
              { className: a[y.Dropdowns], style: c == null ? void 0 : c[y.Dropdowns] },
              f === "dropdown" || f === "dropdown-months" ? u.createElement(n.MonthsDropdown, { className: a[y.MonthsDropdown], "aria-label": Mt(), classNames: a, components: n, disabled: !!t.disableNavigation, onChange: Et(w.date), options: S, style: c == null ? void 0 : c[y.Dropdown], value: s.getMonth(w.date) }) : u.createElement("span", null, _(w.date, s)),
              f === "dropdown" || f === "dropdown-years" ? u.createElement(n.YearsDropdown, { className: a[y.YearsDropdown], "aria-label": Ot(s.options), classNames: a, components: n, disabled: !!t.disableNavigation, onChange: xt(w.date), options: te, style: c == null ? void 0 : c[y.Dropdown], value: s.getYear(w.date) }) : u.createElement("span", null, F(w.date, s)),
              u.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, O(w.date, s.options, s))
            ) : u.createElement(n.CaptionLabel, { className: a[y.CaptionLabel], role: "status", "aria-live": "polite" }, O(w.date, s.options, s))),
            h === "around" && !t.hideNavigation && E === d - 1 && u.createElement(
              n.NextMonthButton,
              { type: "button", className: a[y.NextMonthButton], tabIndex: q ? void 0 : -1, "aria-disabled": q ? void 0 : !0, "aria-label": kt(q), onClick: be, "data-animated-button": t.animate ? "true" : void 0 },
              u.createElement(n.Chevron, { disabled: q ? void 0 : !0, className: a[y.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
            ),
            E === d - 1 && h === "after" && !t.hideNavigation && u.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: a[y.Nav], style: c == null ? void 0 : c[y.Nav], "aria-label": Fe(), onPreviousClick: ve, onNextClick: be, previousMonth: $, nextMonth: q }),
            u.createElement(
              n.MonthGrid,
              { role: "grid", "aria-multiselectable": l === "multiple" || l === "range", "aria-label": yt(w.date, s.options, s) || void 0, className: a[y.MonthGrid], style: c == null ? void 0 : c[y.MonthGrid] },
              !t.hideWeekdays && u.createElement(
                n.Weekdays,
                { "data-animated-weekdays": t.animate ? "true" : void 0, className: a[y.Weekdays], style: c == null ? void 0 : c[y.Weekdays] },
                C && u.createElement(n.WeekNumberHeader, { "aria-label": gt(s.options), className: a[y.WeekNumberHeader], style: c == null ? void 0 : c[y.WeekNumberHeader], scope: "col" }, P()),
                wt.map((Z, he) => u.createElement(n.Weekday, { "aria-label": vt(Z, s.options, s), className: a[y.Weekday], key: he, style: c == null ? void 0 : c[y.Weekday], scope: "col" }, I(Z, s.options, s)))
              ),
              u.createElement(n.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: a[y.Weeks], style: c == null ? void 0 : c[y.Weeks] }, w.weeks.map((Z, he) => u.createElement(
                n.Week,
                { className: a[y.Week], key: Z.weekNumber, style: c == null ? void 0 : c[y.Week], week: Z },
                C && u.createElement(n.WeekNumber, { week: Z, style: c == null ? void 0 : c[y.WeekNumber], "aria-label": bt(Z.weekNumber, {
                  locale: i
                }), className: a[y.WeekNumber], scope: "row", role: "rowheader" }, H(Z.weekNumber, s)),
                Z.days.map((Y) => {
                  const { date: U } = Y, W = ke(Y);
                  if (W[x.focused] = !W.hidden && !!(de != null && de.isEqualTo(Y)), W[R.selected] = (re == null ? void 0 : re(U)) || W.selected, Ee(le)) {
                    const { from: ge, to: Oe } = le;
                    W[R.range_start] = !!(ge && Oe && s.isSameDay(U, ge)), W[R.range_end] = !!(ge && Oe && s.isSameDay(U, Oe)), W[R.range_middle] = Q(le, U, !0, s);
                  }
                  const Ft = br(W, c, t.modifiersStyles), Pt = Yn(W, a, t.modifiersClassNames), At = !Pe && !W.hidden ? mt(U, W, s.options, s) : void 0;
                  return u.createElement(n.Day, { key: `${s.format(U, "yyyy-MM-dd")}_${s.format(Y.displayMonth, "yyyy-MM")}`, day: Y, modifiers: W, className: Pt.join(" "), style: Ft, role: "gridcell", "aria-selected": W.selected || void 0, "aria-label": At, "data-day": s.format(U, "yyyy-MM-dd"), "data-month": Y.outside ? s.format(U, "yyyy-MM") : void 0, "data-selected": W.selected || void 0, "data-disabled": W.disabled || void 0, "data-hidden": W.hidden || void 0, "data-outside": Y.outside || void 0, "data-focused": W.focused || void 0, "data-today": W.today || void 0 }, !W.hidden && Pe ? u.createElement(n.DayButton, { className: a[y.DayButton], style: c == null ? void 0 : c[y.DayButton], type: "button", day: Y, modifiers: W, disabled: W.disabled || void 0, tabIndex: ut(Y) ? 0 : -1, "aria-label": ht(U, W, s.options, s), onClick: pt(Y, W), onBlur: Wt(Y, W), onFocus: Nt(Y, W), onKeyDown: Ct(Y, W), onMouseEnter: St(Y, W), onMouseLeave: _t(Y, W) }, g(U, s.options, s)) : !W.hidden && g(Y.date, s.options, s));
                })
              )))
            )
          );
        })
      ),
      t.footer && u.createElement(n.Footer, { className: a[y.Footer], style: c == null ? void 0 : c[y.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
const so = qt({
  slots: {
    root: ["Calender__root", "relative"],
    picker: [
      "Calender__picker",
      "w-full max-w-fit shadow-md rounded-lg bg-white border p-4"
    ],
    dayButton: [
      "Day__button",
      "hover:bg-gray-100",
      "rounded-full",
      "transition-colors",
      "text-sm",
      "disabled:cursor-not-allowed",
      "disabled:opacity-50"
    ]
  },
  variants: {
    isToday: {
      true: {
        dayButton: ["font-semi-bold text-primary-main"]
      }
    },
    isOutside: {
      true: {
        dayButton: ["text-gray-400"]
      }
    },
    isSelected: {
      true: {
        dayButton: ["bg-primary-main text-white hover:!bg-primary-dark"]
      }
    },
    size: {
      small: {
        dayButton: ["size-8"]
      },
      medium: {
        dayButton: ["size-10"]
      },
      large: {
        dayButton: ["size-12"]
      }
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), {
  root: ao,
  picker: io,
  dayButton: fo
} = so(), yo = (e) => {
  const { value: t, onChange: n, className: r, size: o, disabled: s } = e, [i, a] = ye(t || /* @__PURE__ */ new Date());
  return /* @__PURE__ */ A.jsx("div", { className: ao(), children: /* @__PURE__ */ A.jsx(
    oo,
    {
      disabled: s,
      mode: "single",
      selected: t,
      onSelect: n,
      month: i,
      onMonthChange: a,
      showOutsideDays: !1,
      className: io({ className: r }),
      components: {
        Nav: ({ onPreviousClick: f, onNextClick: l, className: h }) => /* @__PURE__ */ A.jsxs(
          "nav",
          {
            className: `${h} flex items-center justify-around mb-4 gap-4`,
            children: [
              /* @__PURE__ */ A.jsx(
                "button",
                {
                  onClick: f,
                  className: "p-2 hover:bg-gray-100 rounded-lg transition-colors",
                  title: "Previous month",
                  children: /* @__PURE__ */ A.jsx(Xt, { className: "size-5 text-gray-600" })
                }
              ),
              /* @__PURE__ */ A.jsx("h2", { className: "text-xl font-semibold text-gray-900", children: Ge(i, "MMMM yyyy") }),
              /* @__PURE__ */ A.jsx(
                "button",
                {
                  onClick: l,
                  className: "p-2 hover:bg-gray-100 rounded-lg transition-colors",
                  title: "Next month",
                  children: /* @__PURE__ */ A.jsx(tn, { className: "size-5 text-gray-600" })
                }
              )
            ]
          }
        ),
        CaptionLabel: (f) => /* @__PURE__ */ A.jsx("span", { ...f, className: "sr-only" }),
        MonthGrid: ({ children: f }) => /* @__PURE__ */ A.jsx("table", { className: "w-full", children: f }),
        Day: ({ children: f }) => /* @__PURE__ */ A.jsx("td", { className: "text-center", children: f }),
        DayButton: (f) => {
          const { modifiers: l, ...h } = f;
          return /* @__PURE__ */ A.jsx(
            "button",
            {
              ...h,
              disabled: l.disabled,
              className: fo({
                isOutside: l.outside,
                isSelected: l.selected,
                isToday: l.today,
                size: o
              })
            }
          );
        },
        DropdownNav(f) {
          return /* @__PURE__ */ A.jsx(
            "div",
            {
              ...f,
              className: "flex justify-between sm:flex-row flex-col mb-4 gap-4"
            }
          );
        }
        // Dropdown(props) {
        //   const { value, options, onChange } = props;
        //   return (
        //     <Select
        //       defaultValue={value}
        //       value={value}
        //       onChange={(value) => {
        //         const syntheticEvent = {
        //           target: { value },
        //         } as React.ChangeEvent<HTMLSelectElement>;
        //         if (typeof onChange === "function") {
        //           onChange(syntheticEvent);
        //         }
        //       }}
        //       options={options}
        //     />
        //   );
        // },
      }
    }
  ) });
};
export {
  yo as C,
  Je as a
};
